import { useRoutes } from "react-router-dom";
import { useAppSelector } from "../hooks/useAppSelector";
import { protectedRoutes } from "./ProtectedRoute";
import { publicRoutes } from "./PublicRoute";

export const AppRoutes = () => {
  const auth = useAppSelector((x) => x.auth);

  // Sadece backend'den JWT aldıysak (auth.isAuthenticated) protected route'a geç
  // MSAL authenticated olması yeterli değil, backend JWT'si gerekli
  const isAuthenticated = auth.isAuthenticated;

  const protectedElement = useRoutes(protectedRoutes);
  const publicElement = useRoutes(publicRoutes);
  
  return isAuthenticated ? protectedElement : publicElement;
};
